import React, { useContext, useEffect } from "react";
import { AuthContext, ThemeContext } from "../../auth";
import { useMediaQuery } from "react-responsive";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { Container, Form, Image } from "react-bootstrap";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { CiDark, CiGrid41, CiLight } from "react-icons/ci";
import { VscChevronRight } from "react-icons/vsc";
import { PiUsersFourLight } from "react-icons/pi";
import { FaRegHandshake } from "react-icons/fa6";
import { FaRegFileAlt } from "react-icons/fa";
import { LiaUserTieSolid } from "react-icons/lia";
import { RxDashboard } from "react-icons/rx";
import {
  LogoBundar,
  LogoBundarDark,
  LogoCsi,
  LogoCsiBlack,
  LogoFk,
  LogoFkDark,
  LogoGsk,
} from "../../assets/images/image";
import { HiOutlineUserGroup } from "react-icons/hi2";

function SidebarComponent() {
  const {
    userInfo,
    showSidebar,
    mobileSidebar,
    toggleSidebar,
    toggleMobileSidebar,
  } = useContext(AuthContext);
  const { theme, setTheme } = useContext(ThemeContext);
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const location = useLocation();

  const menuItemClass =
    theme === "light" ? "menu-item-dark" : "menu-item-light";

  const roleName = userInfo?.role?.roleName;

  const activeClassPegawai =
    location.pathname === "/pegawai" ||
    location.pathname.startsWith("/tambah-pegawai") ||
    location.pathname.startsWith("/ubah-pegawai")
      ? theme === "light"
        ? "active-menu-item-dark"
        : "active-menu-item-light"
      : "";

  const activeClassLead =
    location.pathname === "/lead" ||
    location.pathname.startsWith("/pcp-penjualan") ||
    location.pathname.startsWith("/pcp-detail") ||
    location.pathname.startsWith("/pcp-sewa") ||
    location.pathname.startsWith("/add-sph")
      ? theme === "light"
        ? "active-menu-item-dark"
        : "active-menu-item-light"
      : "";

  const activeClassDashboard =
    location.pathname === "/dashboard" ||
    location.pathname.startsWith("/dashboard-spv")
      ? theme === "light"
        ? "active-menu-item-dark"
        : "active-menu-item-light"
      : "";

  const activeClassPcp =
    location.pathname === "/pcp" || location.pathname.startsWith("/pcp-approve")
      ? theme === "light"
        ? "active-menu-item-dark"
        : "active-menu-item-light"
      : "";

  const activeClassSales =
    location.pathname === "/sales" ||
    location.pathname.startsWith("/sales-lead") ||
    // || location.pathname.startsWith('/pcp-approve/')
    location.pathname.startsWith("/dashboard-sales") ||
    location.pathname.startsWith("/pcp-detail") ||
    location.pathname.startsWith("/pcp-penjualan") ||
    location.pathname.startsWith("/pcp-sewa")
      ? theme === "light"
        ? "active-menu-item-dark"
        : "active-menu-item-light"
      : "";

  const activeClassCustomer =
    location.pathname === "/customer"
      ? theme === "light"
        ? "active-menu-item-dark"
        : "active-menu-item-light"
      : "";

  const allMenuItems = [
    {
      key: "pegawai",
      path: "/pegawai",
      icon: <PiUsersFourLight size={23} />,
      label: "Pegawai",
      activeClass: activeClassPegawai,
    },
    {
      key: "dashboard",
      path: "/dashboard",
      icon: <RxDashboard size={23} />,
      label: "Dashboard",
      activeClass: activeClassDashboard,
    },
    {
      key: "dashboard-spv",
      path: "/dashboard-spv",
      icon: <RxDashboard size={23} />,
      label: "Dashboard",
      activeClass: activeClassDashboard,
    },
    {
      key: "lead",
      path: "/lead",
      icon: <FaRegHandshake size={23} />,
      label: "Lead",
      activeClass: activeClassLead,
    },
    {
      key: "pcp",
      path: "/pcp",
      icon: <FaRegFileAlt size={23} />,
      label: "PCP",
      activeClass: activeClassPcp,
    },
    {
      key: "sales",
      path: "/sales",
      icon: <LiaUserTieSolid size={23} />,
      label: "Sales",
      activeClass: activeClassSales,
    },
    {
      key: "customer",
      path: "/customer",
      icon: <HiOutlineUserGroup size={23} />,
      label: "Customer",
      activeClass: activeClassCustomer,
    },
  ];

  let filteredMenuItems = [];

  if (roleName === "superuser") {
    filteredMenuItems = allMenuItems;
  } else if (roleName === "Sales") {
    filteredMenuItems = allMenuItems.filter(
      (item) => item.key === "dashboard" || item.key === "lead",
    );
  } else if (roleName === "Supervisor") {
    filteredMenuItems = allMenuItems.filter(
      (item) =>
        item.key === "dashboard-spv" ||
        item.key === "pcp" ||
        item.key === "sales",
    );
  } else if (roleName === "Admin") {
    filteredMenuItems = allMenuItems.filter(
      (item) =>
        item.key === "sales" ||
        item.key === "pegawai" ||
        item.key === "customer",
    );
  } else if (roleName === "Finance") {
    filteredMenuItems = allMenuItems.filter((item) => item.key === "customer");
  } else if (roleName === "Controller") {
    filteredMenuItems = allMenuItems.filter((item) => item.key === "sales");
  }

  const handleToggle = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  useEffect(() => {
    console.log("REAL MOUNT SidebarComponent");
    return () => console.log("REAL UNMOUNT SidebarComponent");
  }, []);

  return (
    <>
      {isMobile === false ? (
        <Sidebar
          id={theme === "light" ? "mySidebarDark" : "mySidebarLight"}
          backgroundColor="rgba(0, 0, 0, 0)"
          width="190px"
          collapsed={showSidebar}
          defaultCollapsed={true}
          onToggle={toggleSidebar}
          style={{ display: "flex", flexDirection: "column", height: "100vh" }}
        >
          <Menu style={{ minHeight: "95%", overflowY: "hidden" }}>
            <Container id="sidebarHeader" className="px-auto py-2 text-center">
              <Image
                className={showSidebar ? "collapsed" : "expanded pt-4"}
                src={theme === "light" ? LogoFkDark : LogoFk}
                fluid
                width={theme === "light" ? 200 : 200}
                style={{ position: showSidebar ? "absolute" : "relative" }}
              />
              <Image
                className={showSidebar ? "expanded pt-4" : "collapsed"}
                src={theme === "light" ? LogoBundarDark : LogoBundar}
                fluid
                width={theme === "light" ? 50 : 100}
                style={{
                  position: showSidebar ? "relative" : "absolute",
                  top: 0,
                  left: 0,
                }}
              />
            </Container>
            <div className="text-center mt-5" />
            <div
              className="icon-box-sidebar"
              onClick={toggleSidebar}
              style={{
                left: showSidebar ? "65px" : "175px",
                cursor: "pointer",
              }}
            >
              {showSidebar ? (
                <IoIosArrowForward
                  size={30}
                  className="icon-arrow-sidebar ms-2"
                  color={theme === "light" ? "#FFFFFF" : "#707070"}
                />
              ) : (
                <IoIosArrowBack
                  size={30}
                  className="icon-arrow-sidebar ms-2"
                  color={theme === "light" ? "#FFFFFF" : "#707070"}
                />
              )}
            </div>
            {/* {showSidebar
                            ? (filteredMenus || []).map((menu) => (
                                <MenuItem
                                    key={menu.label}
                                    className={`mb-3 mx-auto ${menuItemClass} ${activeClass(
                                        menu.label.toLowerCase()
                                    )}`}
                                    component={<NavLink to={menu.path} />}
                                >
                                    {menu.icon}
                                </MenuItem>
                            ))
                            : (filteredMenus || []).map((menu) => (
                                <MenuItem
                                    key={menu.label}
                                    className={`mb-3 mx-auto ${menuItemClass} ${activeClass(
                                        menu.label.toLowerCase()
                                    )}`}
                                    component={<NavLink to={menu.path} />}
                                    icon={menu.icon}
                                    style={{ fontFamily: "Poppins-Regular", fontSize: "15px" }}
                                >
                                    {menu.label}
                                </MenuItem>
                            ))
                        } */}

            {/* <MenuItem
                            className={`mb-3 mx-auto ${menuItemClass} ${activeClassDashboard}`}
                            component={<NavLink to="/dashboard/" />}
                            icon={!showSidebar ? <CiGrid41 size={23} /> : undefined}
                            style={!showSidebar ? { fontFamily: 'Poppins-Regular', fontSize: '15px' } : undefined}
                        >
                            {!showSidebar ? 'Dashboard' : <CiGrid41 size={23} />}
                        </MenuItem> */}

            {filteredMenuItems.map((item) => (
              <MenuItem
                key={item.key}
                className={`mb-3 mx-auto ${menuItemClass} ${item.activeClass}`}
                component={<NavLink to={item.path} />}
                icon={!showSidebar ? item.icon : undefined}
                style={
                  !showSidebar
                    ? { fontFamily: "Poppins-Regular", fontSize: "15px" }
                    : undefined
                }
              >
                {!showSidebar ? item.label : item.icon}
              </MenuItem>
            ))}
          </Menu>
          <div
            className="mt-auto text-center"
            style={{ fontFamily: "Poppins-Medium", fontSize: "13px" }}
          >
            <span className="theme-toggle-container">
              <CiLight
                size={30}
                color={theme === "light" ? "#FFFFFF" : "#222222"}
              />
              <Form.Check
                type="switch"
                className="custom-switch"
                checked={theme === "light"}
                onChange={handleToggle}
              />
              <CiDark
                size={30}
                color={theme === "light" ? "#FFFFFF" : "#222222"}
              />
            </span>
          </div>
        </Sidebar>
      ) : (
        <>
          <Sidebar
            id={theme === "light" ? "mySidebarDark" : "mySidebarLight"}
            backgroundColor={theme === "light" ? "#222222" : "#FFFFFF"}
            width="210px"
            onBackdropClick={toggleMobileSidebar}
            toggled={mobileSidebar}
            breakPoint="all"
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
            }}
          >
            <Menu style={{ minHeight: "95%", overflowY: "hidden" }}>
              <br />
              <Container id="sidebarHeader" className="px-auto py-2" style={{}}>
                <Image
                  src={theme === "light" ? LogoFkDark : LogoFk}
                  fluid
                  width={200}
                />
              </Container>
              <div className="text-center mt-4" style={{}}></div>
              <div
                className="icon-box-sidebar"
                onClick={toggleMobileSidebar}
                style={{
                  left: mobileSidebar ? "0px" : "0px",
                  cursor: "pointer",
                }}
              >
                {mobileSidebar ? (
                  <></>
                ) : (
                  <VscChevronRight
                    size={25}
                    className="icon-toggle-mobile ms-2"
                  />
                )}
              </div>
              {/* {(filteredMenus || []).map((menu) => (

                                <MenuItem
                                    key={menu.label}
                                    className={`mb-3 mx-auto ${menuItemClass} ${activeClass(
                                        menu.label.toLowerCase()
                                    )}`}
                                    component={<NavLink to={menu.path} />}
                                    icon={menu.icon}
                                    style={{ fontFamily: "Poppins-Regular", fontSize: "15px" }}
                                >
                                    {menu.label}
                                </MenuItem>

                            ))} */}

              {filteredMenuItems.map((item) => (
                <MenuItem
                  key={item.key}
                  className={`mb-3 mx-auto ${menuItemClass} ${item.activeClass}`}
                  component={<NavLink to={item.path} />}
                  icon={!showSidebar ? item.icon : undefined}
                  style={
                    !showSidebar
                      ? { fontFamily: "Poppins-Regular", fontSize: "15px" }
                      : undefined
                  }
                >
                  {!showSidebar ? item.label : item.icon}
                </MenuItem>
              ))}
            </Menu>
            <div className="text-center" style={{}}></div>
            <div
              className="mt-auto text-center"
              style={{ fontFamily: "Poppins-Medium", fontSize: "13px" }}
            >
              <span className="theme-toggle-container">
                <CiLight
                  size={30}
                  color={theme === "light" ? "#FFFFFF" : "#707070"}
                />
                <Form.Check
                  type="switch"
                  className="custom-switch"
                  checked={theme === "light"}
                  onChange={handleToggle}
                />
                <CiDark
                  size={30}
                  color={theme === "light" ? "#FFFFFF" : "#707070"}
                />
              </span>
            </div>
          </Sidebar>
        </>
      )}
    </>
  );
}

export default SidebarComponent;
